import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';

import style from './size-inches.module.css';
import { emptyObject } from 'ui-components/default-props/empty';
import { UnitPosition } from '../../../enums/units/unit-position';
import DimensionsLabel from '../../../fulfillment-planner/dimensions/label';
import { DimensionPropType } from '../../../prop-types/dimension';
import { ConvertedDimensionsInput } from '../../converted-dimensions-input/converted-dimensions-input';
import { dimensions } from '../constants';

export const SizeInchesPresetOption = ({ data = emptyObject, onChange }) => {
  const onDimensionsChange = useCallback(
    (value) => {
      onChange({ name: dimensions, value });
    },
    [onChange],
  );

  return (
    <>
      <Text textType={TextType.Label} value={<DimensionsLabel />} />
      <ConvertedDimensionsInput
        className={style['dimension-input']}
        dimensions={data}
        numberInputsContainerClassName={style['number-inputs-container']}
        onChange={onDimensionsChange}
        unitPosition={UnitPosition.InsideStart}
      />
    </>
  );
};

SizeInchesPresetOption.propTypes = {
  data: DimensionPropType,
  onChange: PropTypes.func.isRequired,
};
